export interface PreorderEmptyStateProps {
  campaignError: unknown;
  isErrorExcluding404: boolean;
  isReal404: boolean;
  isNetworkError: boolean;
  getApiBase: () => string;
}

/**
 * 無檔期／錯誤狀態（目前沒有預購檔期或連線錯誤）
 */
export function PreorderEmptyState({
  campaignError,
  isErrorExcluding404,
  isReal404,
  isNetworkError,
  getApiBase,
}: PreorderEmptyStateProps) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4">
      <div className="bg-white rounded-2xl shadow p-6 text-center space-y-4 max-w-md w-full">
        <p className="text-4xl">🥐</p>
        <h1 className="text-xl font-bold text-gray-900">目前沒有預購檔期</h1>
        <p className="text-sm text-gray-600">
          請稍後再回來看看，或加入官方 LINE 以獲得最新通知。
        </p>

        {isNetworkError && (
          <div className="text-xs text-red-600 mt-2 space-y-1">
            <p className="font-semibold">⚠️ 連線錯誤：</p>
            <p>
              {(() => {
                const err = campaignError as unknown;
                return err instanceof Error ? err.message : String(err || '');
              })()}
            </p>
            <p className="text-gray-500 mt-1">
              API URL:{' '}
              {(() => {
                try {
                  return getApiBase();
                } catch {
                  return '未設定';
                }
              })()}
            </p>
          </div>
        )}

        {isErrorExcluding404 && !isNetworkError && !isReal404 && (
          <div className="text-xs text-red-600 mt-2 space-y-1">
            <p className="font-semibold">錯誤：</p>
            <p>
              {(() => {
                const err = campaignError as unknown;
                if (err instanceof Error) {
                  return err.message;
                }
                if (typeof err === 'object' && err !== null) {
                  return JSON.stringify(err, null, 2);
                }
                return String(err);
              })()}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
